import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchProductAccumulated } from 'store/actions/products/fetchProducts';

class ProductField extends React.Component {
    componentDidMount() {
        const { productId, product, fetch } = this.props;

        if (utils.isEmpty(product)) {
            fetch(productId);
        }
    }

    render() {
        const { product } = this.props;

        if (utils.isEmpty(product)) {
            return null;
        }

        return (
            <span>{ product.title }</span>
        );
    }
}

ProductField.propTypes = {
    fetch: PropTypes.func.isRequired,
    productId: PropTypes.string.isRequired,
    product: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const { record, source } = props;

    let identifier = null;

    if (record[source]) {
        identifier = record[source];
    }

    return {
        product: state.products.data[identifier],
        productId: identifier,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (productId) => {
            dispatch(fetchProductAccumulated({
                id: productId,
            }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductField);



// WEBPACK FOOTER //
// ./src/components/field/ProductField.js